<template>
  <div class="loader-invoice">
    <span v-if="hasIcon" class="icon-invoice" width="40" height="40" viewBox="0 0 24 24">
      <base-icon  :name="icon" size="lg" class="mr-1 text-secondary-600 dark:text-darkblue-400"/>
    </span>
    <svg v-else >
    </svg>
    <span class="loader-text text-sm font-semibold text-secondary-600 dark:text-darkblue-400 block mb-1">{{ text }}</span>
  </div>
</template>

<script>
import icons from '@/components/icons/_iconLibrary'
import { i18n } from '@/i18n'

export default {
  name: 'InvoiceLoader',
  props: {
    icon: {
      type: String,
      default: 'none',
      validator (value) {
        return icons.includes(value)
      }
    },    
    text: {
      type: String,
      default: i18n.t('invoices.loading_invoices')
    }
  },
  computed: {
    hasIcon: function () {
      return this.icon !== 'none' && icons.includes(this.icon)
    }
  }
}
</script>

<style scoped>
.loader-invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  overflow: hidden;
}
.loader-invoice > 
.icon-invoice {
  animation: slideLeftRight 2.2s ease-in-out infinite;
}
@keyframes slideLeftRight {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  10% {
    opacity: 1;
    transform: translateX(0);
  }
  60% {
    opacity: 1;
    transform: translateX(0);
  }
  80% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 0;
    transform: translateX(100px);
  }
}
.loader-text {
  margin-top: 16px;
  font-size: 1.1rem;
  color: var(--secondary-800);
  animation: blink 1.6s infinite;
}

.dark .loader-text {
  margin-top: 16px;
  font-size: 1.1rem;
  color: var(--darkblue-100);
  animation: blink 1.6s infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.75; }
}

.base-color-icon{
  fill: var(--secondary-500)
}
</style>
